import React from 'react';

const STEPS = [
  {
    num: '1',
    icon: '📋',
    title: 'Register & Submit Photo ID',
    body: 'Download the RAKSHA app and sign up with your name, phone, email, and a photograph of your government-issued ID. Our administrative team manually reviews each account to guarantee identity verification.',
    illus: '📝',
  },
  {
    num: '2',
    icon: '☝️',
    title: 'Tap SOS in an Emergency',
    body: 'In any threat or unsafe scenario, open the app and tap the large SOS button. RAKSHA immediately queries your smartphone GPS hardware, locking your exact location coordinates within seconds.',
    illus: '🆘',
  },
  {
    num: '3',
    icon: '📡',
    title: 'Broadcast to Vetted Community',
    body: 'Your emergency SOS is securely uploaded and instantly routed to all approved community safety members within range (1–2 km radius), bypassing lock screens with priority push alerts.',
    illus: '📲',
  },
  {
    num: '4',
    icon: '📱',
    title: 'Receive Live Confirmation',
    body: "The moment a nearby responder swipes 'I'll Help', your phone vibrates and updates with their name and ETA. You know exactly who is coming to assist, reducing panic and uncertainty.",
    illus: '✅',
  },
  {
    num: '5',
    icon: '🤝',
    title: 'Safe Resolution',
    body: 'The responder reaches your location. Together you confirm you are safe. The alert is deactivated, resolved, and logged in your encrypted safety history vault for future audits.',
    illus: '🛡️',
  },
];

export default function HowItWorks() {
  return (
    <main>
      {/* Page Hero */}
      <div className="page-hero">
        <div className="rk-container">
          <span className="page-hero-label">How It Works</span>
          <h1 className="page-hero-title">Step-By-Step Network Flow</h1>
          <p className="page-hero-sub">
            Learn how the RAKSHA Ireland community coordinates rapid physical response when an emergency SOS is triggered.
          </p>
        </div>
      </div>

      {/* Steps */}
      <section className="rk-section">
        <div className="rk-container">
          <div className="hiw-steps">
            {STEPS.map(s => (
              <div className="hiw-step" key={s.num}>
                <div className="hiw-step-num">{s.num}</div>
                <div>
                  <h3 className="hiw-step-title">
                    <span style={{ marginRight: 10 }}>{s.icon}</span>
                    {s.title}
                  </h3>
                  <p className="hiw-step-body">{s.body}</p>
                </div>
                <div className="hiw-step-illus">
                  <span style={{ fontSize: '3rem' }}>{s.illus}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Community Code */}
      <section className="rk-section rk-section-dark">
        <div className="rk-container" style={{ textAlign: 'center', maxWidth: 700 }}>
          <span className="rk-section-label rk-section-label-light">Community Safety Code</span>
          <h2 className="rk-section-title rk-section-title-white">A network built on mutual respect and vetting</h2>
          <p className="rk-section-sub rk-section-sub-white" style={{ marginBottom: 36 }}>
            RAKSHA is not a replacement for Gardaí (police) or professional ambulance crews.
            It is a neighbour-to-neighbour physical backup system. Our strict code of conduct ensures all members
            act with the utmost integrity, respect, and compliance during emergency safety operations.
          </p>
          <a href="#download" className="hero-btn-primary" style={{ display: 'inline-flex', margin: '0 auto' }}>
            <i className="bi bi-shield-fill"></i>
            Become a Verified Member
          </a>
        </div>
      </section>
    </main>
  );
}
